import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  initialize() {
    const awesomplete = new Awesomplete(this.element)

    $(this.element).keyup(function (event) {
      if (
        event.keyCode === 37 ||
        event.keyCode === 38 ||
        event.keyCode === 39 ||
        event.keyCode === 40 ||
        event.keyCode === 13
      ) {
        return
      }

      return $.getJSON(`/admin/users/search?query=${this.value}`, function (data) {
        const list = []

        data.forEach((user) => {
          let name = `#${user.id} ${user.email}`
          if (user.first_name) {
            name = `#${user.id} ${user.email} — ${user.first_name} ${user.last_name}`
          }

          list.push([name, user.id])
        })

        awesomplete.list = list
        awesomplete.evaluate()
        return
      })
    })
  }
}
